// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"378":"d00ec990","461":"5595ada8","749":"68ae1c3c","787":"fa7a80ff","897":"debb0b39","912":"c437298d"}[chunkId] + ".chunk.js";
};